import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

import constants from '../../ahm-constants';
import selectCart from '../select-cart';
import selectLocation from '../select-location';

const {
  PRODUCT_TYPE,
  URLS: { SALES },
} = constants;

// @ts-expect-error - Automatic, Please fix when editing this file
const isCombiningHospitalWithExtras = (cart, pathname) => {
  const hasExtrasInCart = get('baseProductType', cart) === PRODUCT_TYPE.EXTRAS;
  const hasHospitalInCart = get('baseProductType', cart) === PRODUCT_TYPE.HOSPITAL;
  const hasCombinedProductInCart = get('product.type', cart) === PRODUCT_TYPE.COMBINED;

  const isCombiningHospital = pathname === `${SALES.PRODUCT_LISTING_HOSPITAL}/add` && hasExtrasInCart;
  const isCombiningExtras = pathname === `${SALES.PRODUCT_LISTING_EXTRAS}/add` && hasHospitalInCart;

  return (isCombiningHospital || isCombiningExtras) && !hasCombinedProductInCart;
};

const selectIsCombiningHospitalWithExtras = createSelector([selectCart, selectLocation], isCombiningHospitalWithExtras);

export default selectIsCombiningHospitalWithExtras;
